module.exports = __webpack_public_path__ + "static/media/mulan.4339c3a6.mp3";